import api from '../../api';

const getDefaultState = () => ({
  isLoading: false,
  errorMessage: '',
  /**  [{ shipmentId: shipmentId1 items: [...], nextToken}, shipmentId: shipmentId2: ... }] */
  shipmentsData: [],
});

function transformShipmentLocation(location) {
  return {
    timestamp: location.timestamp,
    latitude: location.coordinate?.latitude || null,
    longitude: location.coordinate?.longitude || null,
    error: location.error || null,
    address: location.address || null,
  };
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    START_LOADING(state) {
      state.isLoading = true;
    },
    STOP_LOADING(state) {
      state.isLoading = false;
    },
    SET_ERROR_MESSAGE(state, errorMessage) {
      state.errorMessage = errorMessage;
    },
    CLEAR_ERROR_MESSAGE(state) {
      state.errorMessage = '';
    },
    SET_SHIPMENTS_DATA(state, {
      shipmentId, items, nextToken, reset,
    }) {
      if (reset) {
        state.shipmentsData = state.shipmentsData.filter((d) => d.shipmentId !== shipmentId);
      }
      const existingData = state.shipmentsData.find((d) => d.shipmentId === shipmentId);

      const transformedItems = (items || []).map(transformShipmentLocation);
      if (existingData) {
        existingData.items = [...(existingData.items || []), ...transformedItems];
        existingData.nextToken = nextToken;
      } else {
        state.shipmentsData.push({
          shipmentId, items: transformedItems, nextToken,
        });
      }
    },
  },
  actions: {
    async getShipmentLocations(context, { shipmentId, reset, allData }) {
      context.commit('CLEAR_ERROR_MESSAGE');
      context.commit('START_LOADING');
      try {
        const existingData = context.state.shipmentsData.find((d) => d.shipmentId === shipmentId);
        if (reset || !existingData || existingData.nextToken !== null) {
          const data = await api.getConsignmentLocations(
            shipmentId,
            reset ? null : (existingData || {}).nextToken,
          );
          context.commit('SET_SHIPMENTS_DATA', { ...data, shipmentId, reset });
        }
      } catch (error) {
        context.commit('SET_ERROR_MESSAGE', error.message);
        if (allData) {
          throw error;
        }
      } finally {
        context.commit('STOP_LOADING');
      }
    },
    async getAllShipmentLocations(context, { shipmentId, reset }) {
      try {
        const shipmentData = context.state.shipmentsData.find((d) => d.shipmentId === shipmentId);
        const nextToken = shipmentData?.nextToken;
        if (reset || !shipmentData || nextToken) {
          await context.dispatch('getShipmentLocations', { shipmentId, allData: true, reset });
        }
        // check whether there is still data to get
        if ((context.state.shipmentsData
          .find((d) => d.shipmentId === shipmentId) || {}).nextToken) {
          await context.dispatch('getAllShipmentLocations', { shipmentId });
        }
      } catch (error) {
        context.commit('SET_ERROR_MESSAGE', error.message);
      }
    },
  },
};
